export interface CandidateDetail {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber: string | null;
  email: string;
  gender: string | null;
  dateOfBirth: string | null;
  professionalStatus: string | null;
  school: string | null;
  studiesEndYear: number | null;
  comment: string | null;
  roomId: string | null;
  roomName: string | null;
  roomNumber: number | null;
  roomSlug: string | null;
  colocSlug: string | null;
  status: CandidateStatus;

  guarantorType: GuarantorType;
  guarantorSchemeCode: string | null;
  guarantorFirstName: string | null;
  guarantorLastName: string | null;
  guarantorEmail: string | null;
  guarantorPhoneNumber: string | null;
  guarantorGender: string | null;
  guarantorDateOfBirth: string | null;
  guarantorProfessionalStatus: string | null;
  guarantorSchool: string | null;

  dateCreated: string | null;
  dateModified: string | null;
}

export type CandidateStatus =
  | 'PENDING'
  | 'ACCEPTED'
  | 'STANDBY'
  | 'CONFIRMED'
  | 'REJECTED';

export type GuarantorType = 'NONE' | 'INDIVIDUAL' | 'INSTITUTIONAL';

export interface OwnerGuarantorScheme {
  id: string;
  userId: string;
  schemeCode: string;
  schemeLabel: string;
  isActive: boolean;
  dateCreated: string | null;
  dateModified: string | null;
}

export const getCandidateStatusLabel = (status: CandidateStatus): string => {
  switch (status) {
    case 'PENDING': return 'En attente';
    case 'ACCEPTED': return 'Accepté';
    case 'STANDBY': return 'En attente (réserve)';
    case 'CONFIRMED': return 'Locataire';
    case 'REJECTED': return 'Rejeté';
  }
};

export const getCandidateStatusColor = (status: CandidateStatus): string => {
  switch (status) {
    case 'PENDING': return '#ff9800';
    case 'ACCEPTED': return '#2196f3';   // blue — accepted, lease in flight
    case 'STANDBY': return '#9e9e9e';    // grey — paused, not rejected
    case 'CONFIRMED': return '#4caf50';  // green — lease signed, tenant
    case 'REJECTED': return '#f44336';
  }
};

export const PROFESSIONAL_STATUS_LABELS: Record<string, string> = {
  ETUDIANT: 'Étudiant(e)',
  SALARIE: 'Salarié(e)',
  INDEPENDANT: 'Indépendant(e)',
  FONCTIONNAIRE: 'Fonctionnaire',
  DEMANDEUR_EMPLOI: "Demandeur d'emploi",
  RETRAITE: 'Retraité(e)',
  AUTRE: 'Autre',
};

export const GENDER_LABELS: Record<string, string> = {
  Mr: 'Homme',
  Mme: 'Femme',
};

export interface CandidateFile {
  id: string;
  enrollmentCandidateId: string;
  documentName: string;
  filepath: string;
  isGuarantorFile: boolean;
  dateCreated: string | null;
}


export interface AcceptCandidateRequest {
  // Phase 1: only EXTERNAL_PRE_SIGNED is supported (backend rejects
  room_id: string;
  first_name: string;
  last_name: string;
  email: string;
  /**
   * RETIRÉ de l'interface : le bailleur choisissait le mot de passe de son
   * locataire, donc connaissait l'accès à son dossier — le même défaut avait
   * déjà été corrigé sur la finalisation du bail (audit P1-4), sans être
   * reporté ici. L'API l'ignorait de toute façon : le compte naît avec un
   * secret aléatoire et son titulaire définit le sien via un lien.
   */
  phone_number?: string;
  gender?: string;
  date_of_birth?: string;
  school?: string;
  lease_start_date: string;
  monthly_rent: number;
  charges_provision: number;
  deposit_amount?: number;
  agency_expenses?: number;
}
